

const initialState = {
    litigationTypeMasterError: {
      litigationNameErr: {},
    }
  };
  
  const litigationTypeMasterErrorReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LITIGATIONERROR':
        if (!action.payload) {
          return initialState;
        } else {
          return {
            ...state,
            litigationTypeMasterError: action.payload
          };
        }
      default:
        return state;
    }
  };
  
  export default litigationTypeMasterErrorReducer;